export default __webpack_public_path__ + "static/1483-e0cda43052a3234130c85730b14e9213.gif";